import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { Simplert } from 'vue2-simplert-plugin'
import "../styleguide.css"
import "../globals.css"
import 'vue2-simplert-plugin/dist/vue2-simplert-plugin.min.css'

Vue.config.productionTip = false;
Vue.use(Simplert);

new Vue({
  render: h => h(App),
  router
  }).$mount("#app");

router.afterEach((to, from) => {
  gtag('event', 'page_view', {page_path: to.path});
});